module.exports = __webpack_public_path__ + "img/myposition_wb.470d1b22.svg";